import { Data } from '../data';
import { TipoRotaData } from '../tipo-rota.data';

export class UsuarioLogadoData extends Data<UsuarioLogadoData> {
    idUsuario!: number;
    idParceiro!: number;
    nomeUsuario!: string;
    descLogin!: string;
    descEmail!: string;
    cpf!: string;
    indAdministradorGeral!: number;
    idTipoUsuario!: number;
    idHierarquia!: number;
    indStatus!: string;
    usuario!: string;
    permissoes!: TipoRotaData[];

    // TODO: Novos dados retornados - Solicitar ao Luciano
    nomeParceiro!: string;
    urlParceiro!: string;
    descHierarquia!: string;
    idCocorretor?: number;
}
